import {
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import {
  EGroupFindPermission,
  EGroupViewContentPermission,
} from '@/graphql-types/globalTypes';
import { getPermissionLabel } from '@/utilities';

export const CanViewContentConfig: React.FC<{
  isEditing: boolean;
  availablePermissions: Map<
    EGroupFindPermission,
    {
      viewContentPermissions: EGroupViewContentPermission[];
    }
  >;
}> = ({ isEditing, availablePermissions }) => {
  const { watch, setValue } = useFormContext();
  const findConfigValue = watch('canFindConfig');
  const viewContentConfigValue = watch('canViewContentConfig');
  const allowedCanViewContentValues =
    availablePermissions.get(findConfigValue)?.viewContentPermissions;

  React.useEffect(() => {
    if (
      !allowedCanViewContentValues ||
      allowedCanViewContentValues.length === 0
    ) {
      setValue('canViewContentConfig', undefined);
    } else if (!allowedCanViewContentValues.includes(viewContentConfigValue)) {
      setValue('canViewContentConfig', allowedCanViewContentValues[0]);
    }
  }, [allowedCanViewContentValues, setValue, viewContentConfigValue]);

  if (
    !allowedCanViewContentValues ||
    allowedCanViewContentValues.length === 0
  ) {
    return null;
  }

  return (
    <FormControl as="fieldset">
      <FormLabel as="legend">Who Can View the Content in this Group?</FormLabel>
      {isEditing ? (
        <Controller
          name="canViewContentConfig"
          render={({ field: { onChange, value, ref } }) => (
            <RadioGroup value={value} onChange={onChange} ref={ref}>
              <VStack spacing="2" width="full" alignItems="start">
                {allowedCanViewContentValues.map((detail) => (
                  <Radio
                    key={detail}
                    aria-label={
                      getPermissionLabel({ viewContent: detail }) || ''
                    }
                    value={detail}
                  >
                    {getPermissionLabel({ viewContent: detail })}
                  </Radio>
                ))}
              </VStack>
            </RadioGroup>
          )}
        ></Controller>
      ) : (
        <Text color="gray.600">
          {getPermissionLabel({ viewContent: viewContentConfigValue })}
        </Text>
      )}
    </FormControl>
  );
};
